export const RAFFLE_DEAL__ERROR_MAP = {
  BAD_REQUEST: '잘못된 요청입니다.',
  CONFLICT: '이미 응모했습니다.',
  PRECONDITION_FAILED: '응모 가능시간이 아닙니다.',
  NOT_FOUND: '해당하는 프로모션 또는 딜 상품이 없습니다.',
  UNAVAILABLE_PERIOD: '응모 기간이 아닙니다.',
  SERVER_ERROR: '요청에 실패했습니다.',
};

export const RAFFLE_DEAL_PAGE_NAME = 'Promotion';
export const RAFFLE_DEAL_PAGE_TYPE = 'Event';
export const RAFFLE_DEAL_LOGIN = '회원';
export const RAFFLE_DEAL_LOGOUT = '비회원';
